export type UserRole = 'user' | 'admin' | 'moderator' | 'analyst';

export type Permission = 
  | 'view_dashboard'
  | 'use_tools'
  | 'manage_users'
  | 'view_analytics'
  | 'manage_content'
  | 'access_api';

export interface UserProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  permissions: Permission[];
  createdAt: Date;
  updatedAt: Date;
  lastLoginAt?: Date;
  emailVerified: boolean;
  failedLoginAttempts: number;
  accountLocked: boolean;
  accountLockedUntil?: Date;
  twoFactorEnabled: boolean;
  twoFactorSecret?: string;
}

// Role-based permission mapping
export const rolePermissions: Record<UserRole, Permission[]> = {
  user: ['view_dashboard', 'use_tools'],
  analyst: ['view_dashboard', 'use_tools', 'view_analytics'],
  moderator: ['view_dashboard', 'use_tools', 'view_analytics', 'manage_content'],
  admin: ['view_dashboard', 'use_tools', 'view_analytics', 'manage_content', 'manage_users', 'access_api']
};
